import Vue from 'vue';
import moment from 'moment';

Vue.filter('orderDate', value => value != null ? moment(String(value)).format("DD MMMM YYYY") : '');
Vue.filter('orderTime', value => value != null ? moment(String(value)).format("HH.mm") : '');
Vue.filter('caps', value => value != null ? value[0].toUpperCase() + value.substring(1) : '');